/**
 * @description DateRangePicker 의 value를 포매팅해주는 함수
 */
const getDateRangeInfo = (start?: Date | null, end?: Date | null) => {
  if (!start && !end) return null;

  return {
    start: start ?? null,
    end: end ?? null,
  };
};

export default getDateRangeInfo;
